// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"96":"vendors","517":"calendar","694":"theme"}[chunkId] + ".css";
};